// Recovered compiled webpack factory 35000. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  let r;
  function n(e) {
    var t;
    return (
      (null ==
      (t = (function () {
        if (void 0 === r) {
          var e;
          r =
            (null == (e = window.trustedTypes)
              ? void 0
              : e.createPolicy("nextjs", {
                  createHTML: (e) => e,
                  createScript: (e) => e,
                  createScriptURL: (e) => e,
                })) || null;
        }
        return r;
      })())
        ? void 0
        : t.createScriptURL(e)) || e
    );
  }
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "__unsafeCreateTrustedScriptURL", {
      enumerable: !0,
      get: function () {
        return n;
      },
    }),
    ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
      void 0 === t.default.__esModule &&
      (Object.defineProperty(t.default, "__esModule", { value: !0 }),
      Object.assign(t.default, t),
      (e.exports = t.default)));
}
